(() => {
  const cartPage = document.querySelector('.cart-page');
  if (!cartPage) return;

  let activeSharePayload = null;

  function getCartPageRoot() {
    return document.querySelector('.cart-page');
  }

  function getShareModal() {
    return document.querySelector('[data-share-modal]');
  }

  function getShareModalCopy() {
    return document.querySelector('[data-share-modal-copy]');
  }

  function getShareFeedback() {
    return document.querySelector('[data-share-feedback]');
  }

  function getShareCopyButton() {
    return document.querySelector('[data-share-copy]');
  }

  function getShareWhatsapp() {
    return document.querySelector('[data-share-whatsapp]');
  }

  function getShareInstagram() {
    return document.querySelector('[data-share-instagram]');
  }

  function getShareTiktok() {
    return document.querySelector('[data-share-tiktok]');
  }

  function showShareFeedback(message) {
    const shareFeedback = getShareFeedback();
    if (!shareFeedback) return;

    shareFeedback.hidden = false;
    shareFeedback.textContent = message;
  }

  function clearShareFeedback() {
    const shareFeedback = getShareFeedback();
    if (!shareFeedback) return;

    shareFeedback.hidden = true;
    shareFeedback.textContent = '';
  }

  async function copyText(value) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  function openShareModal(payload) {
    const shareModal = getShareModal();
    const shareModalCopy = getShareModalCopy();
    const shareWhatsapp = getShareWhatsapp();

    if (!shareModal) return;

    activeSharePayload = payload;
    clearShareFeedback();

    if (shareModalCopy) {
      shareModalCopy.textContent = `Share ${payload.variantLabel ? `${payload.title} · ${payload.variantLabel}` : payload.title}.`;
    }

    if (shareWhatsapp) {
      const whatsappText = `${payload.title}${payload.variantLabel ? ` (${payload.variantLabel})` : ''} — ${payload.url}`;
      shareWhatsapp.href = `https://wa.me/?text=${encodeURIComponent(whatsappText)}`;
    }

    shareModal.hidden = false;
    document.body.classList.add('modal-open');
  }

  function closeShareModal() {
    const shareModal = getShareModal();
    if (!shareModal) return;

    shareModal.hidden = true;
    document.body.classList.remove('modal-open');
    activeSharePayload = null;
    clearShareFeedback();
  }

  async function shareItem(payload) {
    const shareTitle = payload.variantLabel ? `${payload.title} · ${payload.variantLabel}` : payload.title;
    const shareText = `Check out ${shareTitle} on HoHo Makes`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: payload.url
        });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        console.error(error);
      }
    }

    openShareModal(payload);
  }

  document.addEventListener('click', async (event) => {
    const currentCartPage = getCartPageRoot();
    if (!currentCartPage) return;

    const shareButton = event.target.closest('[data-cart-share]');
    if (shareButton && currentCartPage.contains(shareButton)) {
      const row = shareButton.closest('.cart-line');
      if (!row) return;

      event.preventDefault();
      shareItem({
        title: row.getAttribute('data-share-title') || '',
        variantLabel: row.getAttribute('data-share-variant') || '',
        url: row.getAttribute('data-share-url') || window.location.href
      });
      return;
    }

    const shareClose = event.target.closest('[data-share-close]');
    if (shareClose) {
      event.preventDefault();
      closeShareModal();
      return;
    }

    const shareCopyButton = event.target.closest('[data-share-copy]');
    if (shareCopyButton) {
      event.preventDefault();
      if (!activeSharePayload) return;

      const copied = await copyText(activeSharePayload.url);
      showShareFeedback(copied ? 'Link copied.' : 'Could not copy the link.');
      return;
    }

    const shareInstagram = event.target.closest('[data-share-instagram]');
    if (shareInstagram) {
      event.preventDefault();
      if (!activeSharePayload) return;

      const copied = await copyText(activeSharePayload.url);
      showShareFeedback(copied ? 'Link copied — paste it into Instagram.' : 'Could not copy the link.');
      window.open('https://www.instagram.com/', '_blank', 'noopener');
      return;
    }

    const shareTiktok = event.target.closest('[data-share-tiktok]');
    if (shareTiktok) {
      event.preventDefault();
      if (!activeSharePayload) return;

      const copied = await copyText(activeSharePayload.url);
      showShareFeedback(copied ? 'Link copied — paste it into TikTok.' : 'Could not copy the link.');
      window.open('https://www.tiktok.com/', '_blank', 'noopener');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !getShareModal()?.hidden) {
      closeShareModal();
    }
  });

  document.addEventListener('cart-page:replaced', () => {
    document.body.classList.remove('modal-open');
    activeSharePayload = null;
    clearShareFeedback();
  });

  window.HohoCartPageShare = {
    open: openShareModal,
    close: closeShareModal
  };
})();